import { RowPaymentMethodDto } from "@/dtos";
import { PaymentMethod } from "@/entities";
import { getPaymentMethodStatusOption, getPaymentMethodTypeOption } from "@/helpers/options";

export const formatRowPaymentMethodDto = (paymentMethods: PaymentMethod[]): RowPaymentMethodDto[] => {
    return paymentMethods.map(x => {
        const row: RowPaymentMethodDto = {
            ...x,
            passenger_label: x.passenger ? x.passenger.first_name + " " + x.passenger.last_name : "S/N",
            active: x.is_active ? 'Activo' : 'Inactivo',
            fare_type_label: x.fare_type?.name ?? 'S/N',
            type_label: getPaymentMethodTypeOption(x.type).label,
            status_label: getPaymentMethodStatusOption(x.status).label,
            identificative_label: x.identificative != '' ? x.identificative : 'S/N',
            uid: (!x.uid || x.uid == '') ? 'S/N' : x.uid,
            brand_label: x.brand?.name ?? 'S/N'
        }

        return row;
    });
}